import { useQuery, gql } from "@apollo/client";

export const GET_ALL_TITLE_ANALYTICS = gql`
  query GetAllTitleAnalyticsForHostDashboard($search: String!) {
    getAllTitleAnalyticsForHostDashboard(search: $search) {
      noOfTitles
      titlesEarnedCity {
        trialCalendarId
        trialCount
        city
      }
      titlesEarnedBreed {
        breedCount
        breed
      }
      titlesEarnedAge {
        count
        ageYears
      }
    }
  }
`;

export const GET_TRIAL_ANALYTICS = gql`
  query getTrialAnalyticsForHostDashboard {
    getTrialAnalyticsForHostDashboard {
      noOfTrialEarned
      noOfQualification
      noOfNonQualification
    }
  }
`;

export const GET_ALL_TITLE_FOR_ADMIN_ANALYTICS = gql`
  query getAllTitleAnalyticsDashboard($search: String!) {
    getAllTitleAnalyticsDashboard(search: $search) {
      noOfTitles
      titlesEarnedCity {
        trialCalendarId
        trialCount
        city
      }
      titlesEarnedBreed {
        breedCount
        breed
      }
      titlesEarnedAge {
        count
        ageYears
      }
    }
  }
`;

export const GET_TRIAL_FOR_ADMIN_ANALYTICS = gql`
  query getTrialAnalyticsForDashbaord {
    getTrialAnalyticsForDashbaord {
      noOfTrialEarned
      noOfQualification
      noOfNonQualification
    }
  }
`;

export const GET_ALL_FOR_HOST_ADMIN_TITLES = gql`
  query GetAllTitles {
    getAllTitles {
      search
    }
  }
`;
